import React from 'react';
import { FlameIcon } from 'lucide-react';
export function TopBar() {
  return <div className="w-full border-b border-naranja/30 bg-naranja/15" data-id="element-194" data-mp="232wyrqn2b0vp">
      
    </div>;
}